/**
 * Are the contents of two arrays equal, ignoring the order?
 */
export function arrayContentsEqual(
  array1: any[],
  array2: any[],
  equals: Function = (a: any, b: any) => a === b
) {
  function contains(arr: any[], el: any) {
    return arr.findIndex((el2) => equals(el, el2)) !== -1;
  }

  const arr1AllInArr2 = array1.filter((el) => !contains(array2, el)).length === 0;
  const arr2AllInArr1 = array2.filter((el) => !contains(array1, el)).length === 0;

  return arr1AllInArr2 && arr2AllInArr1;
}
